export interface Cartridge {
	Id: number | null;
	Name: string;
	Description: string;
	MillSizeId: number | null;
	MillSizeName: string | null;
	Active: boolean;
}

export const CARTRIDGE_INITIAL_VALUES: Cartridge = {
	Id: null,
	Name: "",
	Description: "",
	MillSizeId: null,
	MillSizeName: null,
	Active: true,
};

export interface MillSize {
	Id: number;
	Name: string;
	Description: string;
	Active: boolean;
}
